import { rutinInfos } from '../../_Common/Const/RutinInfo';
import notImplemented from '../../_Common/Components/notImplemented/notImplemented';
import { withAddStartedRoutine } from '../../../StartPanel/Components/Cards/StartedRoutines/startedRoutineQueries';
import { createListRutin } from '../../_Common/Components/ListRutin/ListRutin';
import getStandardRutin from '../../_Common/Utils/getStandardRutin';

const OFRutiner = {
  rtnKreditorder: {
    component: getStandardRutin(rutinInfos.rtnKreditorder, 'OFOrder'), // Samma som rtnOrder
  },
  rtnKundfakturabunt: {
    component: getStandardRutin(
      rutinInfos.rtnKundfakturabunt,
      'KRKundfakturabunt'
    ),
  },
  rtnOrderunderlag: {
    component: getStandardRutin(rutinInfos.rtnOrderunderlag, 'OFOrderunderlag'),
  },
  rtnFakturatext: {
    component: getStandardRutin(rutinInfos.rtnFakturatext, 'LAFakturatext'),
  },
  rtnPrislista: {
    component: getStandardRutin(rutinInfos.rtnPrislista, 'LAPrislista'),
  },

  rtnPrisavtal: {
    component: getStandardRutin(rutinInfos.rtnPrisavtal, 'OFPrisavtal'),
  },
  rtnWebOrder: {
    component: getStandardRutin(rutinInfos.rtnWebOrder, 'OFOrder'),
  },
  rtnOrderrad: {
    component: getStandardRutin(rutinInfos.rtnOrderrad, 'OFOrderrad'),
  },
  rtnRantefakturering: {
    component: withAddStartedRoutine(rutinInfos.rtnRantefakturering)(
      createListRutin(
        'KRFaktura',
        [
          { attributeDef: 'Kund.KUNDNR_KONTONR', caption: 'Kundnr' },
          { attributeDef: 'Kund.Namn', caption: 'Namn' },
          { attributeDef: 'Faktura_nr', caption: 'Fakturanr' },
          { attributeDef: 'Fakturabelopp', caption: 'Fakturabelopp' },
          { attributeDef: 'FORFALLO_DATUM', caption: 'Förfallodatum' },
          { attributeDef: 'SenasteBetalnDatum', caption: 'Sen bet dat' },
          { attributeDef: 'CalcDrojsmalsranta', caption: 'Dröjsmålsränta' },
          { attributeDef: 'CalcPaminnelseavgift', caption: 'Påminnelseavgift' },
          {
            attributeDef: 'Betalningsvillkor.Text',
            caption: 'Betalningsvillkor',
          },
          { attributeDef: 'Felorsak', caption: 'Felorsak' },
        ],
        notImplemented('Drojsmalsrantefakturering DetailComp')
      )
    ),
  },
  rtnRanteomgang: {
    component: getStandardRutin(rutinInfos.rtnRanteomgang, 'OFRanteomgang'),
  },
  rtnArtikelgrupp: {
    component: getStandardRutin(rutinInfos.rtnArtikelgrupp, 'LAArtikelgrupp'),
  },
  rtnOrderkategori: {
    component: getStandardRutin(rutinInfos.rtnOrderkategori, 'OFOrderkategori'),
  },
};

export default OFRutiner;
